/** Blank / Auto-generate / scoping on Create New. Both launch flags plus a concrete case. */
export function isTimelineCreateAutoGenerateEnabled(
  flags: { betterWand?: boolean; chatAutogenTimeline?: boolean } | undefined,
  caseId: string | undefined,
): boolean {
  return (
    !!flags?.betterWand &&
    !!flags?.chatAutogenTimeline &&
    !!caseId &&
    caseId.trim() !== '' &&
    caseId !== '*' &&
    caseId !== 'All Cases'
  );
}
